import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';

import Display_Group_Cell_Icon from './Display_Group_Cell_Icon';
import Display_Group_Cell_Label from './Display_Group_Cell_Label';
import Display_Group_Cell_Option from './Display_Group_Cell_Option';
import Display_Scene_Cell_Icon from './Display_Scene_Cell_Icon';
import Display_Scene_Cell_Label from './Display_Scene_Cell_Label';
import Display_Report_Cell_Icon from './Display_Report_Cell_Icon';
import Display_Report_Cell_Label from './Display_Report_Cell_Label';
import Display_Mp_Cell_Icon from './Display_Mp_Cell_Icon';
import Display_Mp_Cell_Label from './Display_Mp_Cell_Label';
import Display_Mp_Cell_AV from './Display_Mp_Cell_AV';
import Display_Mp_Cell_Meter from './Display_Mp_Cell_Meter';
import Display_Mp_Cell_Mode from './Display_Mp_Cell_Mode';
import Display_Mp_Cell_SP from './Display_Mp_Cell_SP';
import Display_Mp_Cell_Hum_SP from './Display_Mp_Cell_Hum_SP';
import Display_Mp_Cell_Temp from './Display_Mp_Cell_Temp';
import Display_Layout_Cell_Icon from './Display_Layout_Cell_Icon';
import Display_Layout_Cell_Label from './Display_Layout_Cell_Label';
import Display_ACSummary_Cell from './Display_ACSummary_Cell';
import Display_PowerSummary_Cell from './Display_PowerSummary_Cell';

export default class Target_Cell extends Component {
	constructor(props) {
		super(props);
		let x = 0;
		let y = 0;
		if (!isEmpty(this.props.target_info)) {
			x = this.props.target_info.x;
			y = this.props.target_info.y;
		}

		this.state = {
			x: x,
			y: y,
			showToolTip: false
		}

		// Original position of mouse when dragging starts
		this.mouse_start_x = 0;
		this.mouse_start_y = 0;

		// Original position of element before dragging
		this.orig_pos_x = x;
		this.orig_pos_y = y;

		// reference to power_summary component
		this.power_summary = React.createRef();

		// Whether this component is activated to move
		this.is_active = false;

		this.scenes = this.props.scenes;

		// Only load scenes user has access to
		if (this.props.receiver.active_controller.user_class != 'Admin') { //If user class is not Admin
			let temp_scenes = {};
			let accessible_points = this.props.receiver.active_controller.auth.points;
			for (let key in this.scenes) {
				for (let mp in this.scenes[key].action) {
					if (accessible_points.hasOwnProperty(mp)) { //If user has access to at least 1 mp
						temp_scenes[key] = this.scenes[key];
					}
				}
			}
			this.scenes = temp_scenes;
		}
	}

	rcvMonthlyMeter = (monthly_meter) => {
		this.power_summary.current.rcvMonthlyMeter(monthly_meter);
	}

	onMouseEnter = () => {
		this.setState({ showToolTip: true });
	}

	onMouseLeave = () => {
		this.setState({ showToolTip: false });
	}

	onDragStart = (event) => {
		event.preventDefault();
		if (this.props.is_movable) {
			if (event.clientX != null && !isNaN(event.clientX)) {
				this.mouse_start_x = event.clientX;
				this.mouse_start_y = event.clientY;
			} else {
				let touch = event.touches[0];
				this.mouse_start_x = touch.clientX;
				this.mouse_start_y = touch.clientY;
			}

			this.is_active = true;
			this.orig_pos_x = this.state.x;
			this.orig_pos_y = this.state.y;
		} else {
			this.handleOnClick();
		}
	}

	onDrag = (event) => {
		event.preventDefault();
		if (this.props.is_movable && this.is_active) {
			let mouse_end_x = 0;
			let mouse_end_y = 0;

			if (event.clientX != null && !isNaN(event.clientX)) {
				mouse_end_x = event.clientX;
				mouse_end_y = event.clientY;
			} else {
				let touch = event.touches[0];
				mouse_end_x = touch.clientX;
				mouse_end_y = touch.clientY;
			}

			// current position of target cell 
			let pos_x = this.orig_pos_x;
			let pos_y = this.orig_pos_y;

			let offset_x = mouse_end_x - this.mouse_start_x;
			let offset_y = mouse_end_y - this.mouse_start_y;

			// new position of target cell
			pos_x = pos_x + offset_x;
			pos_y = pos_y + offset_y;

			//if shiftKey pressed, snap to grid
			if (event.shiftKey) {
				pos_x = Math.round(pos_x / 10) * 10;
				pos_y = Math.round(pos_y / 10) * 10;
			}

			this.setState({ x: pos_x, y: pos_y });
		}
	}

	onDragEnd = (event) => {
		event.preventDefault();
		//this.is_active = false;
		if (this.props.is_movable) {
			let mouse_end_x = 0;
			let mouse_end_y = 0;

			if (event.clientX != null && !isNaN(event.clientX)) {
				mouse_end_x = event.clientX;
				mouse_end_y = event.clientY;
			} else {
				let touch = event.touches[0];
				mouse_end_x = touch.clientX;
				mouse_end_y = touch.clientY;
			}

			// current position of target cell 
			let pos_x = this.orig_pos_x;
			let pos_y = this.orig_pos_y;

			let offset_x = mouse_end_x - this.mouse_start_x;
			let offset_y = mouse_end_y - this.mouse_start_y;

			// new position of target cell
			pos_x = pos_x + offset_x;
			pos_y = pos_y + offset_y;

			this.setState({ x: pos_x, y: pos_y });

			this.props.handleChangePosition(pos_x, pos_y, this.props.index);
		}
	}

	handleOnClick = () => {
		if (!this.props.is_movable) {
			switch (this.props.target_info.type) {
				//case 'group':
				case 'groupIcon':
				case 'groupLabel':
				case 'groupOption':
					let group_info = this.props.groups[this.props.target_info.id];
					if (!isEmpty(group_info)) {
						this.props.content_handler('Group_Details', { group_info: group_info, group_id: this.props.target_info.id, from: 'Layout', layout_id: this.props.layout_id });
					}
					break;
				case 'sceneIcon':
				case 'sceneLabel':
					let scene_info = this.scenes[this.props.target_info.id];
					if (!isEmpty(scene_info)) {
						this.props.receiver.executeScene(this.props.target_info.id);
					}
					break;
				case 'layoutIcon':
				case 'layoutLabel':
					let display_layout_info = this.props.layouts[this.props.target_info.id];
					if (!isEmpty(display_layout_info)) {
						this.props.handleChangeLayout(this.props.target_info.id);
					}
					break;
				case 'mpointsIcon':
				case 'mpointsLabel':
				case 'mpointsAv':
				case 'mpointsMeter':
				case 'mpointsMode':
				case 'mpointsSp':
				case 'mpointsHumSp':
				case 'mpointsTemp':
					let point_info = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info)) {
						if (point_info.comm_stat && point_info.op_cap) {
							let param = {};
							param.point_id = this.props.target_info.id;
							param.point_info = point_info;
							param.from = 'Layout';
							param.layout_id = this.props.layout_id;
							this.props.content_handler('Operation_Screen', param);
						}
					}
					break;
				case 'reportIcon':
				case 'reportLabel':
					/*
					 * Remember to add 'Layout' in handlePrevious function 
					 */
					this.props.handleReport(this.props.target_info.id);
					break;
				case 'acsummary':
				case 'powersummary':

					break;
				default:

			}
		} else {
			this.props.handleSelectedCell(this.props.target_info.id, this.props.target_info.type);
		}
	}

	render() {
		/*
		 * Smallest cell
		 * Width: 75
		 * height: 50
		 * icon width: 25
		 * Additional info icon = 10
		 * fontSize 10
		 */
		let coefficient = 25; // controls the increment in size
		let cell_width = 50 + (coefficient * this.props.target_info.size);
		let cell_height = (cell_width / 3) * 2;
		let display_elem = null; // Display elem will be generated dynamically according to target type

		// Need to identify all the management points that are AC in the layout
		// For acsummary and powersummary
		let display_Ac_points = [];
		for (let target_info of this.props.layout_info.target) {
			if (!isEmpty(window.app.state.point_list[target_info.id])) { // If it exists in point_list
				if (window.app.state.point_list[target_info.id].type == 'Ac') { // If type = Ac
					display_Ac_points.push(target_info.id);
				}
			}
		}

		if (!isEmpty(this.props.target_info)) {
			switch (this.props.target_info.type) {
				case 'groupIcon':
					let group_info_icon = this.props.groups[this.props.target_info.id];
					if (!isEmpty(group_info_icon)) {
						display_elem =
							<Display_Group_Cell_Icon
								group_info={group_info_icon}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'groupLabel':
					let group_info_label = this.props.groups[this.props.target_info.id];
					if (!isEmpty(group_info_label)) {
						display_elem =
							<Display_Group_Cell_Label
								group_info={group_info_label}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'groupOption':
					let group_info_option = this.props.groups[this.props.target_info.id];
					if (!isEmpty(group_info_option)) {
						display_elem =
							<Display_Group_Cell_Option
								group_info={group_info_option}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'sceneIcon':
					let scene_info_icon = this.scenes[this.props.target_info.id];
					if (!isEmpty(scene_info_icon)) {
						display_elem =
							<Display_Scene_Cell_Icon
								scene_info={scene_info_icon}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'sceneLabel':
					let scene_info_label = this.scenes[this.props.target_info.id];
					if (!isEmpty(scene_info_label)) {
						display_elem =
							<Display_Scene_Cell_Label
								scene_info={scene_info_label}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'layoutIcon':
					let display_layout_info_icon = this.props.layouts[this.props.target_info.id];
					if (!isEmpty(display_layout_info_icon)) {
						display_elem =
							<Display_Layout_Cell_Icon
								layout_info={display_layout_info_icon}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'layoutLabel':
					let display_layout_info_label = this.props.layouts[this.props.target_info.id];
					if (!isEmpty(display_layout_info_label)) {
						display_elem =
							<Display_Layout_Cell_Label
								layout_info={display_layout_info_label}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
							/>
					}
					break;
				case 'mpointsIcon':
					let point_info_icon = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_icon)) {
						display_elem =
							<Display_Mp_Cell_Icon
								point_info={point_info_icon}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'mpointsLabel':
					let point_info_label = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_label)) {
						display_elem =
							<Display_Mp_Cell_Label
								point_info={point_info_label}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'mpointsAv':
					let point_info_av = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_av)) {
						display_elem =
							<Display_Mp_Cell_AV
								point_info={point_info_av}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'mpointsMeter':
					let point_info_meter = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_meter)) {
						display_elem =
							<Display_Mp_Cell_Meter
								point_info={point_info_meter}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'mpointsMode':
					let point_info_mode = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_mode)) {
						display_elem =
							<Display_Mp_Cell_Mode
								point_info={point_info_mode}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'mpointsSp':
					let point_info_sp = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_sp)) {
						display_elem =
							<Display_Mp_Cell_SP
								point_info={point_info_sp}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
								is_movable={this.props.is_movable}
							/>
					}
					break;
				case 'mpointsHumSp':
					let point_info_hum_sp = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_hum_sp)) {
						display_elem =
							<Display_Mp_Cell_Hum_SP
								point_info={point_info_hum_sp}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
								is_movable={this.props.is_movable}
							/>
					}
					break;
				case 'mpointsTemp':
					let point_info_temp = window.app.state.point_list[this.props.target_info.id];
					if (!isEmpty(point_info_temp)) {
						display_elem =
							<Display_Mp_Cell_Temp
								point_info={point_info_temp}
								receiver={this.props.receiver}
								size={this.props.target_info.size}
								cell_width={cell_width}
								info={this.props.target_info.info}
							/>
					}
					break;
				case 'reportIcon':
					display_elem =
						<Display_Report_Cell_Icon
							name={this.props.target_info.id}
							receiver={this.props.receiver}
							size={this.props.target_info.size}
							cell_width={cell_width}
						/>
					break;
				case 'reportLabel':
					display_elem =
						<Display_Report_Cell_Label
							name={this.props.target_info.id}
							receiver={this.props.receiver}
							size={this.props.target_info.size}
							cell_width={cell_width}
						/>
					break;
				/*case 'acsummary':
					cell_width = 300 + (coefficient * this.props.target_info.size);
					cell_height = (cell_width/2);
					display_elem = 
						<Display_ACSummary_Cell 
							receiver={this.props.receiver}
							size={this.props.target_info.size}
							cell_width={cell_width}
							cell_height={cell_height}
							display_Ac_points={display_Ac_points}
						/>
					break;*/
				/*case 'powersummary':
					cell_width = 300 + (coefficient * this.props.target_info.size);
					cell_height = (cell_width/3) * 2;
					display_elem = 
						<Display_PowerSummary_Cell 
							ref={this.power_summary}
							receiver={this.props.receiver}
							size={this.props.target_info.size}
							cell_width={cell_width}
							cell_height={cell_height}
							display_Ac_points={display_Ac_points}
						/>
					break;*/
				default:

			}
		}

		let cell_style = {
			//width: cell_width, 
			//height: cell_height,
			//margin: 5,
			//padding: 10,
			//boxShadow: this.props.target_info.selectedIcon ? '1px 1px 2px 2px rgba(0, 0, 0, 0.1)' : 'none',				//Use border as selectable icon
			//borderRadius: 20,
			cursor: 'pointer',
			textAlign: 'center',
			position: 'absolute',
			top: this.state.y,
			left: this.state.x,
			zIndex: this.state.showToolTip ? '999999' : this.props.index
		}

		let toolTipStyle = {
			top: '50px',
			left: '10px',
			display: this.state.showToolTip ? 'block' : 'none',
			fontSize: '14px',
			position: 'absolute',
			color: 'black',
			backgroundColor: 'white',
			border: '1px solid navy',
			padding: '1px 2px',
			zIndex: '999999',
			whiteSpace: 'nowrap'
		}

		let targetCellName = '';

		switch (this.props.target_info.type) {
			case 'groupIcon':
			case 'groupLabel':
			case 'groupOption':
				if (this.props.groups.hasOwnProperty(this.props.target_info.id)) {
					if (this.props.groups[this.props.target_info.id].hasOwnProperty('name')) {
						targetCellName = 'Group: ' + this.props.receiver.getString(this.props.groups[this.props.target_info.id].name);
					}
				}
				break;
			case 'sceneIcon':
			case 'sceneLabel':
				if (this.scenes.hasOwnProperty(this.props.target_info.id)) {
					if (this.scenes[this.props.target_info.id].hasOwnProperty('name')) {
						targetCellName = 'Scene: ' + this.scenes[this.props.target_info.id].name;
					}
				}
				break;
			case 'layoutIcon':
			case 'layoutLabel':
				if (this.props.layouts.hasOwnProperty(this.props.target_info.id)) {
					if (this.props.layouts[this.props.target_info.id].hasOwnProperty('name')) {
						targetCellName = 'Layout: ' + this.props.layouts[this.props.target_info.id].name;
					}
				}
				break;
			case 'mpointsIcon':
			case 'mpointsLabel':
			case 'mpointsAv':
			case 'mpointsMeter':
			case 'mpointsMode':
			case 'mpointsSp':
			case 'mpointsHumSp':
			case 'mpointsTemp':
				if (window.app.state.point_list.hasOwnProperty(this.props.target_info.id)) {
					if (window.app.state.point_list[this.props.target_info.id].hasOwnProperty('name')) {
						targetCellName = 'Device: ' + window.app.state.point_list[this.props.target_info.id].name;
					}
				}
				break;
			case 'reportIcon':
			case 'reportLabel':
				switch (this.props.target_info.id) {
					case 'trend':
						targetCellName = 'Report: ' + this.props.receiver.getString('trend_graph');
						break;
					case 'energy_management':
						targetCellName = 'Report: ' + this.props.receiver.getString('energy_management');
						break;
					case 'water_management':
						targetCellName = 'Report: ' + this.props.receiver.getString('water_management');
						break;
					case 'op_info':
						targetCellName = 'Report: ' + this.props.receiver.getString('operation_info_report');
						break;
					case 'error_info':
						targetCellName = 'Report: ' + this.props.receiver.getString('err_reporting_report');
						break;
					default:
					// code block	
				}

				break;
			default:

		}

		return (
			<div
				id={'target_cell_' + this.props.index}
				style={cell_style}
				draggable
				onMouseDown={this.onDragStart}
				onMouseMove={this.onDrag}
				onMouseUp={this.onDragEnd}
				onMouseEnter={this.onMouseEnter}
				onMouseLeave={this.onMouseLeave}
				onTouchStart={this.onDragStart}
				onTouchMove={this.onDrag}
				onTouchEnd={this.onDragEnd}
				onClick={this.handleOnClick}
			>
				{display_elem}
				<div style={toolTipStyle}> {targetCellName} </div>
			</div>
		)
	}
}